export default __webpack_public_path__ + "static/right-gradient-2ce0507769227e495ac43496d6f3c061.svg";